import { Alert } from 'avo-ui'
import { CategorySection } from 'components/award/nomination/category-section/CategorySection'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    is_show: false,
    title_image_url: null,
    description: null,
    categories: [
        {
            image_url: null,
            title: null,
        },
    ],
}

export const CategorySectionContainer = () => {
    const [categoryDetail, setCategoryDetail] = useState(INITIAL_STATE)
    const copyItems = [...(categoryDetail?.categories || [])]
    const [errorForm, setErrorForm] = useState({})
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getCategory, isLoading } = useFetch(API_AWARD.NOMINATION_CATEGORY)
    const { fetching: updateCategory, isLoading: isUpdating } = useFetch({
        ...API_AWARD.NOMINATION_CATEGORY,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)

    useEffect(() => {
        fetchCategory()
    }, [])

    const fetchCategory = async () => {
        const response = await getCategory()
        let responseData = response?.data

        if (response?.data?.categories?.length === 0) {
            responseData = {
                ...responseData,
                categories: [
                    {
                        image_url: null,
                        title: null,
                    },
                ],
            }
        }
        setCategoryDetail(responseData)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setCategoryDetail({ ...categoryDetail, [name]: value })
    }

    const setItems = (items) => {
        setCategoryDetail({ ...categoryDetail, categories: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                image_url: null,
                title: null,
            },
        ])
    }

    const handleUploadImage = async (files) => {
        let newFormImage = {}
        if (files?.title_image_url) {
            const s3Urls = await getURLImage({ files: [files?.title_image_url?.name] })
            await uploadFileToS3(s3Urls?.data?.[0], files?.title_image_url?.file)
            newFormImage = {
                ...newFormImage,
                title_image_url: `${s3Urls?.data?.[0]?.url}${s3Urls?.data?.[0]?.fields?.key}`,
            }
        }

        if (files?.categories?.length > 0) {
            let newFiles = []
            const fileNames = files?.categories.map((item) => item.image_url.name)
            const s3Urls = await getURLImage({ files: fileNames })

            await Promise.all(
                s3Urls?.data?.map(async (item, index) => {
                    const itemFile = { image_url: '', currentIndex: '' }
                    await uploadFileToS3(item, files?.categories[index]?.image_url?.file)
                    itemFile.image_url = `${item?.url}${item?.fields?.key}`
                    itemFile.currentIndex = files?.categories[index]?.currentIndex
                    newFiles.push(itemFile)
                }),
            )
            newFormImage = { ...newFormImage, categories: [...newFiles] }
        }

        return newFormImage
    }

    const validationForm = () => {
        const newErrorForm = { ...errorForm }
        if (!categoryDetail.title_image_url) {
            newErrorForm.title_image_url = 'Image title wajib diisi'
        } else {
            newErrorForm.title_image_url = ''
        }

        const errorArrayItem = []
        for (const item of categoryDetail.categories) {
            const itemError = { image_url: '', title: '' }
            if (!item.image_url) itemError.image_url = 'Image icon wajib diisi'
            if (!item.title) itemError.title = 'Title wajib diisi'
            errorArrayItem.push(itemError)
        }
        newErrorForm.categories = [...errorArrayItem]

        return newErrorForm
    }
    const isValid = (data) => {
        if (typeof data === 'string') {
            return data === ''
        }
        if (Array.isArray(data)) {
            return data.every(isValid)
        }
        if (typeof data === 'object' && data !== null) {
            return Object.values(data).every(isValid)
        }
        return false
    }

    const onSubmit = async () => {
        const findErrors = validationForm()
        setErrorForm(findErrors)
        if (!isValid(findErrors)) return

        let files = {}
        if (categoryDetail?.title_image_url?.file)
            files = { ...files, title_image_url: categoryDetail?.title_image_url }

        let payload = { ...categoryDetail }

        const fileArray = categoryDetail.categories
            .map((item, index) => ({ ...item, currentIndex: index }))
            .filter((item) => item?.image_url?.file)

        if (fileArray.length > 0) {
            files = { ...files, categories: fileArray }
        }

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            const filePayload = await handleUploadImage(files)
            if (filePayload?.title_image_url) {
                payload = {
                    ...payload,
                    title_image_url: filePayload?.title_image_url,
                }
            }

            if (filePayload?.categories?.length > 0) {
                for (const itemFile of filePayload?.categories) {
                    payload.categories[itemFile?.currentIndex].image_url = itemFile?.image_url
                }
            }
            setLoadingUpload(false)
        }
        await updateCategory(payload)
        await fetchCategory()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Category Section Updated!',
        })
    }

    const props = {
        data: categoryDetail,
        items: copyItems,
        setItems,
        onChangeForm,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <CategorySection {...props} />
}
